import { useEffect, useState } from "react";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import styled, { createGlobalStyle, css } from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { swSettings } from "app/common/services/swSettings";
import { SubsectionItem } from "@similarweb/ui-components";
import { EPrimaryItemType } from "@similarweb/ui-components";
import { allTrackers } from "app/services/track/track";

const { blue } = colorsPalettes;

declare const window: {
    Beamer?: {
        update: (config) => void;
    };
};

const GlobalStyles = createGlobalStyle`
    .beamerAnnouncementSnippet {
        display: none
    }
`;

const badgeStyle = () => {
    return css`
        background: ${blue[400]} !important;
        ${mixins.setFontVariant("tag", colorsPalettes.carbon["0"])};
        padding: 4px 5px;
        height: 8px;
        border-radius: 16px;
        position: absolute;
        align-items: center;
        justify-content: space-around;
        top: 7px;
        left: 175px;
        animation: none;
        display: flex;
    `;
};

const Container = styled.div<{ isCollapsed: boolean }>`
    position: relative;

    .beamer_icon.active {
        ${badgeStyle}
        ${({ isCollapsed }) => isCollapsed && `display:none;`}
    }
`;

// DO NOT change this id, Since its configured in google tag manager
const BEAMER_ELEMENT_ID = "beamer-elm";

const buildFilterString = (): string => {
    try {
        const { hasSI, hasMR, hasDM, plan } = swSettings.user;
        let filterString = "";

        if (hasDM) {
            filterString = "DMI;";
        }

        if (hasMR) {
            filterString += "DRI;";
        }

        if (hasSI) {
            filterString += "SI;";
        }

        if (hasDM && hasMR) {
            filterString += "DS;";
        }

        if (plan) {
            filterString += `${plan};`;
        }

        return filterString;
    } catch (ex) {
        return "";
    }
};

export const BeamerButton = ({ isBarOpen }: { isBarOpen: boolean }) => {
    const translate = useTranslation();
    const { Beamer } = window;
    const filterString = buildFilterString();
    const [beamerReady, setBeamerReady] = useState<boolean>(false);
    const onBeamerReady = () => {
        setBeamerReady(true);
    };

    useEffect(() => {
        $(document).on("BeamerReady", onBeamerReady);
        return () => {
            $(document).off("BeamerReady", onBeamerReady);
        };
    }, []);

    useEffect(() => {
        // Add event listeners to beamer in order to track open/close
        if (beamerReady && Beamer && typeof Beamer.update === "function") {
            const { id, username, lastname, firstname } = swSettings.user;
            Beamer.update({
                onopen: () => {
                    allTrackers.dispatchTrackEvent("Side Menu", "open", "Open Beamer Menu");
                },
                onclose: () => {
                    allTrackers.dispatchTrackEvent("Side Menu", "close", "Close Beamer Menu");
                },
                filter: filterString,
                user_id: id,
                user_email: username,
                user_firstname: firstname,
                user_lastname: lastname,
            });
        }
    }, [beamerReady]);

    if (!Beamer) {
        return null;
    }
    return (
        <Container
            id={BEAMER_ELEMENT_ID}
            isCollapsed={!isBarOpen}
        >
            <GlobalStyles />
            <SubsectionItem
                key={BEAMER_ELEMENT_ID}
                itemText={translate("whats.new.title")}
                icon={"sidebar3-updates-news"}
                itemType={EPrimaryItemType.SecondaryAction}
                isCollapsed={!isBarOpen}
            />
        </Container>
    );
};
